import React from 'react'
import { Parser } from "json2csv";
import { useCallback, useEffect, useRef } from "react";

export const getPropertyValueByString = (object, property) => {
    property = property.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    property = property.replace(/^\./, '');           // strip a leading dot
    var a = property.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in object) {
            object = object[k];
            if(object === null) {
                return;
            }
        } else {
            return;
        }
    }
    return object;
}

export const createTeamsDeepLink = (appId, entityId, entityWebUrl, isWebUrlRelative) => {
    const url = new URL(entityWebUrl, window.location.href);
    var context = '';

    if (isWebUrlRelative) 
        entityWebUrl = url.href;
    if (url.hash)
        context = `&context=${encodeURIComponent(`{"subEntityId": "${url.hash.substr(1)}"}`)}`;

    return `https://teams.microsoft.com/l/entity/${appId}/${entityId}?webUrl=${encodeURIComponent(entityWebUrl)}${context}`;
}

export const groupBy = (xs, key) => {
    return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}


export function useIsMounted() {
  const isMountedRef = useRef(true);
  const isMounted = useCallback(() => isMountedRef.current, []);

  useEffect(() => {
    return () => void (isMountedRef.current = false);
  }, []);

  return isMounted;
}

export const renderDate = (date) => date ? date.split('T')[0] : '';
  
export const renderDateTime = (date, multiline = false) => date 
    ? multiline
        ?  <span>{date.split('T')[0].split('.')[0]}<br />{date.split('T')[1].split('.')[0]}</span> 
        : date.replace('T',  ', ').split('.')[0]
    : '';

export const addDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

export const addPivotItemKeyToUrl = (parentPivotKey) => (pivotItem) =>  document.location.hash = parentPivotKey ? `${parentPivotKey}/${pivotItem.props.itemKey}` : pivotItem.props.itemKey;

export const getPivotItemKeyFromUrl = (defaultKey, parentPivotKey) => {
    
    const before = new RegExp(`.*${parentPivotKey}/?`, 'g');
    const after = new RegExp('/.*', 'g');
    const defauleSelectedKeyFromHash = (window.location.hash && window.location.hash.substr(1)).replace(before, '').replace(after, '');
    const defaultSelectedKey = defauleSelectedKeyFromHash ? defauleSelectedKeyFromHash : defaultKey;

    if (!document.location.hash || (document.location.hash === `#${parentPivotKey}`)) {
        window.history.pushState(null, defaultSelectedKey, '#' + (parentPivotKey ? `${parentPivotKey}/${defaultSelectedKey}` : defaultSelectedKey));
    }

    return defaultSelectedKey;
}

export const trimAny = (str, chars) => {
    var start = 0, 
        end = str.length;

    while(start < end && chars.indexOf(str[start]) >= 0)
        ++start;

    while(end > start && chars.indexOf(str[end - 1]) >= 0)
        --end;

    return (start > 0 || end < str.length) ? str.substring(start, end) : str;
}

export class String {
    //String.format("{0} comes before {1}", "a", "b")     
    static format(stringToFormat, ...tokens) { 
        return stringToFormat.replace(/{(\d+)}/g, function (match, number) { 
            return typeof tokens[number] !== 'undefined' ? tokens[number] : match; 
        }); 
    };
}

export function isValidGuid(str) { 
    if (!str) return false;

    let regex = new RegExp(/^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/);
    
    return regex.test(str);
}

export function rootSiteQuotaUsage(site){
    return site.quotaUsage > 0 || site.quotaUsage === 0 ? site.quotaUsage : (site.statistics ? site.statistics.storageUsedMB : 0);
}

export function channelsQuotaUsage(channels){
        if(channels){
        return channels.reduce(function(prev, current) {
            return prev + +current.quotaUsage
        }, 0);
    } else {
        return 0;
    }
}

export function renderQuota(q) {
    if (q != null) {
        const qString = q < 1000 ? `${q} GB` : `${Math.round(q/1000)} TB`;
        return qString;
    }
}

export function renderQuotaUsage(siteQuotaUsage, siteQuotaValue, statisticsQuotaUsage = null, decimals = 2) {
    // quotaUsage >= 0 doesn't work if quotaUsage = null
    const quotaUsage = siteQuotaUsage > 0 || siteQuotaUsage === 0 ? siteQuotaUsage : statisticsQuotaUsage
    if (!(quotaUsage > 0)) return '0 MB'
    
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['MB', 'GB', 'TB', 'PB', 'EB', 'ZB']

    const i = Math.floor(Math.log(quotaUsage) / Math.log(k))

    return `${parseFloat((quotaUsage / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}${siteQuotaValue > 0 ? ` (${percentageQuotaUsage(quotaUsage, siteQuotaValue)}%)` : ``}`
}

export function percentageQuotaUsage(quotaUsage, QuotaValue){
    return Math.round(quotaUsage / (QuotaValue * 1000) * 100)
}

export const mapUserForPeople = (user) => {
    return [{
        name: user ? user.displayName : 'None'
    }];
}

export const mapEnumToOptions = (enumObject) => Object.values(enumObject).map(x => ({key: x, text: x}))

export const mapEnumToValues = (enumObject) => Object.values(enumObject)

export const mapEnumToFilterValues = (enumObject) => Object.keys(enumObject).map(x => ({ key: x, value: enumObject[x] }))

export const mapBooleanToFilterValues = () => [{ key: true, value: 'Yes'}, { key: false, value: 'No'}]

export const mapEnumToOptionsWithValues = (enumObject) => Object.keys(enumObject).map(x => ({ key: x, text: enumObject[x] }))

export const getOptionFromEnumValue = (option, enumObject) => Object.keys(enumObject).find(x => enumObject[x] === option)


export const createAndDownloadCsv = (items, fileName, fields) => {

    const transform = (item) =>  Object.fromEntries(
        Object.entries(item).map(([k, v]) => [k, typeof v === 'string' ? v.replace(/\r?\n/g, ' ') : v])
    );

    //withBOM parameter is required to support Unicode characters 
    let opts = { fields, delimiter: ';', withBOM: true, transforms: [transform] };
    let parser = new Parser(opts);
    let csv = parser.parse(items);
    let formattedData = csv.replace(/"/g, '').replace(/T00:00:00/g, '');
    let link = document.createElement("a");
    link.setAttribute("href", URL.createObjectURL(new Blob([formattedData], { type: "application/octet-stream"})));
    link.setAttribute("download", `${fileName}_${new Date().toISOString()}.csv`);
    document.body.appendChild(link); 
    link.click();
    document.body.removeChild(link);
}

export const renderNumber = (x) => {
    return x !== null ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : '-'
}

export const renderUser = (user) =>  user && (user.email ? <span title={user.email}>{user.email}</span> : <span title={user.displayName}>{user.displayName}</span>)

export const renderBoolean = (value) => <span>{value ? 'Yes' : 'No'}</span>

export const renderManagement = (value) => value && <span>{value.key}</span>

export const renderGeography = (value) => value && <span>{value.value}</span>

export const getGroupedItems = (items, groupByKey, groupNameKey) => {
    const sortItems = (items, groupBy) => {
        const groups = new Map();

        for (const item of items) {
            const key = item[groupBy] || item.id;
            if (!groups.has(key)) {
                groups.set(key, []);
            }
            groups.get(key).push(item);
        }

        // Flatten the grouped values while maintaining order
        return Array.from(groups.values()).flat();
    }

    const sortedItems = sortItems(items, groupByKey)

    const groups = sortedItems.reduce((acc, cur) => {
        const groupName = cur[groupNameKey] || cur.name
        const groupId = cur[groupByKey] || cur.id;
        
        const group = {
            key: groupId,
            name: `${groupName}`,
            startIndex: 0,
            count: 1,
            isCollapsed: false,
        };
        if (acc.length === 0) {
            acc.push(group);
            return acc;
        } else if (acc[acc.length - 1].key !== groupId) {
            const { count, startIndex } = acc[acc.length - 1];
            acc.push({
            ...group,
            startIndex: count + startIndex,
            });
            return acc;
        }
        acc[acc.length - 1].count++;
        return acc;
    }, []); 

    return [sortedItems, groups];
} 

export const getUrlParams = (paramName) => {
    let url_string = window.location.href;
    let url = new URL(url_string);
    let paramValue = url.searchParams.get(paramName);
    return paramValue;
}

export const removeUrlParam = (param) => {
    window.location.href = window.location.origin + window.location.pathname + window.location.hash
}


// WEBPACK FOOTER //
// ./src/helpers/HelperMethods.js